export function debugLog(what: any) {
}

export const PUBLIC_URL = 'https://realfooding.app/';

export const FIREBASE_CONFIG = {
	apiKey: "AIzaSyDz0jhDAA-ZcPYnkzpRvMCES-8qcb_2NuM",
	authDomain: "realfooding-app.firebaseapp.com",
	databaseURL: "https://realfooding-app.firebaseio.com",
	projectId: "realfooding-app",
	storageBucket: "realfooding-app.appspot.com",
	messagingSenderId: "24888581023"
};



// WEBPACK FOOTER //
// ./src/config.prod.live.js